import { classic } from "./presets/classic";
import { ocean } from "./presets/ocean";
import { forest } from "./presets/forest";
import { rose } from "./presets/rose";
import { sunset } from "./presets/sunset";
import { midnight } from "./presets/midnight";
import { vibrant } from "./presets/vibrant";
import { slate } from "./presets/slate";
import { academyDark } from "./presets/academy-dark";

import type { ThemePreset, ThemeColors } from "./types";

export type { ThemePreset, ThemeColors };

export const THEME_PRESETS: ThemePreset[] = [
  academyDark,
  classic,
  ocean,
  forest,
  rose,
  sunset,
  midnight,
  vibrant,
  slate,
];

export function getThemeById(id: string): ThemePreset | undefined {
  return THEME_PRESETS.find((t) => t.id === id);
}

export function applyThemeColors(colors: ThemeColors): void {
  const root = document.documentElement;
  for (const [key, value] of Object.entries(colors)) {
    root.style.setProperty(`--${key}`, value);
  }
}

const THEME_COLOR_KEYS: (keyof ThemeColors)[] = [
  "background",
  "foreground",
  "card",
  "card-foreground",
  "popover",
  "popover-foreground",
  "primary",
  "primary-foreground",
  "secondary",
  "secondary-foreground",
  "muted",
  "muted-foreground",
  "accent",
  "accent-foreground",
  "destructive",
  "destructive-foreground",
  "border",
  "input",
  "ring",
  "sidebar-background",
  "sidebar-foreground",
  "sidebar-primary",
  "sidebar-primary-foreground",
  "sidebar-accent",
  "sidebar-accent-foreground",
  "sidebar-border",
  "sidebar-ring",
];

export function clearThemeColors(): void {
  const root = document.documentElement;
  for (const key of THEME_COLOR_KEYS) {
    root.style.removeProperty(`--${key}`);
  }
}
